module.exports = __webpack_public_path__ + "static/media/hourglass-half.fcf368aa.svg";